<div id="content" class="allcp-form map-content" ng-controller="CustomerOrderController" ng-init="init()">
<div ng-include="'modules/customer/partials/top_menu.html'"></div>
<div ng-include="'modules/customer/partials/order_filter_menu.html'"></div>
<div class="row">
    <div id="map" ng-click="clearMap()"></div>
    <div class="tab">
        <ul>
            <li ng-class="tab == 0 ? 'active' : '' " ng-click="tab = 0"><a href="#">İşler</a></li>
            <li ng-class="tab == 1 ? 'active' : '' " ng-click="tab = 1"><a href="#">Harita</a></li>
            <li ng-class="tab == 2 ? 'active' : '' " ng-click="tab = 2"><a href="#">Çalışanlar</a></li>
        </ul>
    </div>
    <div ng-include="'modules/customer/partials/left_sidebar.html'"></div>
</div>
</div>
<style>
    html, body {
        height:100% !important;
    }
    #map {
        right: 0px !important;
    }
</style>
<script>
    $(document).ready(function(){
    var height = $(window).height() - 116;
    $('.map-content').css('height',height);
        $(window).resize(function(){
        var height = $(window).height() - 116;
        $('.map-content').css('height',height);
        });
    });
</script>